import {GET, POST} from "@/services/gateway";

const listUsers = ({pagination, search, filter}) => {
  return POST('box/user/list', {pagination, search, filter});
}

const getUserDetails = (id) => {
  return GET('box/drive/user', {id})
}

const listSnapshots = ({userId, date, dateTo}) => {
  return POST('box/drive/snapshot/list', {userId, date, dateTo})
}

const createBackup = (userId) => {
  return GET('box/drive/backup', {userId})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, snapshotId, selectedIds, code, extension, storageDestinationId, dataType, storageDestinationType}) => {
  return POST('box/drive/export', {snapshotDateTime, sourceIds, searchTerm, snapshotId, selectedIds, extension, storageDestinationId, dataType, storageDestinationType}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, RestoreType, code}) => {
  return POST('box/drive/restore', {snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, RestoreType}, {code: code ? code : null});
}

export {
  listUsers,
  getUserDetails,
  listSnapshots,
  createBackup,
  exportSnapshot,
  restoreSnapshot
}
